import { connect } from 'react-redux';

import EventbritePrivacyTerms from './EventbritePrivacyTerms';

import {
    trackCommunityGuidelinesClicked as trackCommunityGuidelinesClickedAction,
    trackPrivacyPolicyClicked as trackPrivacyPolicyClickedAction,
    trackTermsOfServiceClicked as trackTermsOfServiceClickedAction,
} from '../../actions/gaTracking';

const _mapStateToProps = () => ({});

const _mapDispatchToProps = {
    onTermsOfServiceClick: trackTermsOfServiceClickedAction,
    onComunityGuidelinesClick: trackCommunityGuidelinesClickedAction,
    onPrivacyPolicyClick: trackPrivacyPolicyClickedAction,
};

export default connect(
    _mapStateToProps,
    _mapDispatchToProps,
)(EventbritePrivacyTerms);
